import { makeApiUrl } from '@/main/factories/http';
import { RemoteVirtualTransactions } from '@/data/usecases';
import { makeAuthorizeHttpClientDecorator } from '../../decorators';
export const makeRemoteVirtualTransactions = () => {
    return new RemoteVirtualTransactions(makeApiUrl('/virtual-transactions'), makeAuthorizeHttpClientDecorator());
};
